export const messages = {
  en: {
    maintainanceStandard: {
      search: {
        title: 'Search Conditions',
        standardName: 'Please select maintenance item'
      },
      list: {
        title: 'Maintenance Standard'
      },
      standardDetail: 'Standard Detail',
      noStandardSelected: 'Please select a maintenance standard',
      items: 'Inspection Items',
      itemId: 'ID',
      table: {
        standardName: 'Maintenance Standard',
        itemCount: 'Inspection Items',
        item: 'Items',
        remark: 'Remark',
        createTime: 'Create Time'
      },
      form: {
        standardName: 'Maintenance Item',
        remark: 'Remark'
      },
      placeholder: {
        standardName: 'Required, please fill in the maintenance item',
        remark: 'Required, please fill in the remark'
      },
      rules: {
        standardName: 'Maintenance item cannot be empty',
        standardNameMax: 'Maintenance item cannot exceed 256 characters',
        remark: 'Remark cannot be empty',
        remarkMax: 'Remark cannot exceed 512 characters',
        standardId: 'ID cannot be empty'
      },
      add: {
        title: 'Add Maintenance Standard'
      },
      edit: {
        title: 'Edit Maintenance Standard'
      },
      delete: {
        title: 'Confirm Operation',
        confirmText: 'Are you sure to delete this maintenance standard?'
      },
      message: {
        addSuccess: 'Add successfully',
        addFailed: 'Add failed',
        editSuccess: 'Edit successfully',
        editFailed: 'Edit failed',
        deleteSuccess: 'Delete successfully',
        deleteFailed: 'Delete failed',
        fetchError: 'Failed to fetch data'
      }
    }
  },
  zh: {
    maintainanceStandard: {
      search: {
        title: '查询条件',
        standardName: '请选择保养项目'
      },
      list: {
        title: '保养标准'
      },
      standardDetail: '标准详情',
      noStandardSelected: '请选择保养标准',
      items: '检查项',
      itemId: '编号',
      table: {
        standardName: '保养标准',
        itemCount: '检查项',
        item: '检查项',
        remark: '备注',
        createTime: '创建时间'
      },
      form: {
        standardName: '保养项目',
        remark: '备注'
      },
      placeholder: {
        standardName: '必填，请填写保养项目',
        remark: '必填，请填写备注'
      },
      rules: {
        standardName: '保养项目不能为空',
        standardNameMax: '保养项目不能超过256个字符',
        remark: '备注不能为空',
        remarkMax: '备注不能超过512个字符',
        standardId: '编号不能为空'
      },
      add: {
        title: '添加保养标准'
      },
      edit: {
        title: '修改保养标准'
      },
      delete: {
        title: '请确认您的操作',
        confirmText: '确定删除保养标准?'
      },
      message: {
        addSuccess: '添加成功',
        addFailed: '添加失败',
        editSuccess: '修改成功',
        editFailed: '修改失败',
        deleteSuccess: '删除成功',
        deleteFailed: '删除失败',
fetchError: '获取数据失败'
      }
    }
  },
  'zh-TW': {
    maintainanceStandard: {
      search: {
        title: '查詢條件',
        standardName: '請選擇保養項目'
      },
      list: {
        title: '保養標準'
      },
      standardDetail: '標準詳情',
      noStandardSelected: '請選擇保養標準',
      items: '檢查項',
      itemId: '編號',
      table: {
        standardName: '保養標準',
        itemCount: '檢查項',
        item: '檢查項',
        remark: '備註',
        createTime: '創建時間'
      },
      form: {
        standardName: '保養項目',
        remark: '備註'
      },
      placeholder: {
        standardName: '必填，請填寫保養項目',
        remark: '必填，請填寫備註'
      },
      rules: {
        standardName: '保養項目不能為空',
        standardNameMax: '保養項目不能超過256個字符',
        remark: '備註不能為空',
        remarkMax: '備註不能超過512個字符',
        standardId: '編號不能為空'
      },
      add: {
        title: '添加保養標準'
      },
      edit: {
        title: '修改保養標準'
      },
      delete: {
        title: '確認操作',
        confirmText: '確定刪除保養標準?'
      },
      message: {
        addSuccess: '添加成功',
        addFailed: '添加失敗',
        editSuccess: '修改成功',
        editFailed: '修改失敗',
        deleteSuccess: '刪除成功',
        deleteFailed: '刪除失敗',
        fetchError: '獲取數據失敗'
      }
    }
  }
}